Object.defineProperty(Array, 'toReversed', {
  value () {
    return  [ ...this ].reverse();
  },
  writable: true,
  enumerable: false,
  configurable: true
});
